<template>
    <div class="pb-20">
        <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
            {{trans.get('production.wu_list')}}
        </h1>

        <div class="flex w-full p-4 justify-end">
            <open-modal modal="add-workunit">
                {{trans.get('production.add_new')}}
            </open-modal>
        </div>

        <section class="w-3/4 mx-auto rounded border shadow-lg">
            <table class="table-auto w-full text-sm">
                <thead class="font-bold bg-purple-100">
                <tr>
                    <th class="border-r-2 border-gray-100 px-4 py-2 text-left">
                        {{trans.get('production.work_unit_code')}}
                    </th>
                    <th class="px-4 py-2 text-left">{{trans.get('production.description')}}</th>
                </tr>
                </thead>

                <tbody>
                <p class="text-lg text-gray-500"
                   v-if="workunits.length === 0"
                >
                    {{ trans.get('production.no_wu') }}
                </p>
                <tr class="row" v-for="workunit in workunits">
                    <td class="border-r-2 border-gray-100 px-4 py-1"> {{workunit.id_reparto}}</td>
                    <td class="px-4 py-1"> {{workunit.descrizione}}</td>
                </tr>

                <!-- <button type="button" class="btn btn-primary tooltip hover:text-aitems-600"
                         data-toggle="tooltip border-black text-white bg-black"
                         title="Edit">
                     <i class="far fa-edit"></i>
                 </button>


                 <td>

                     <button type="submit" class="btn btn-primary tooltip hover:text-aitems-600"
                             data-toggle="tooltip border-black text-white bg-black"
                             title="Delete">
                         <i class="far fa-trash-alt"></i>
                     </button>

                 </td>-->

                </tbody>
            </table>
        </section>


        <modal class="modal-form-block"
               name="add-workunit"
               height="auto"
               transition="slide">
            <div class="flex flex-col">

                <div class="w-full flex justify-between items-center py-3 px-1 bg-aitems-700 text-gray-100 mb-6">
                    <div class="font-bold tracking-wide p-2 pl-6 uppercase">{{trans.get('production.add_wu')}}</div>
                    <div class="font-bold p-2 cursor-pointer"
                         @click="$modal.hide('add-workunit')">
                        <i class="fas fa-times-circle"></i>
                    </div>
                </div>

                <WorkUnitCreator @wu-has-been-created="onWuHasBeenCreated"></WorkUnitCreator>

            </div>
        </modal>
    </div>
</template>

<script>
    import OpenModal from "./buttons/openModal";
    import WorkUnitCreator from "./WorkUnitCreator.vue";

    export default {
        name: "WorkUnitList",

        components: {
            OpenModal,
            WorkUnitCreator,
        },

        props: [
            'wu'
        ],

        data() {
            return {
                workunits: this.wu
            }
        },

        methods: {
            onWuHasBeenCreated(wu) {
                console.log(wu);
                this.workunits.push(wu);
                console.log('Aggiornato!');
                this.$modal.hide('add-workunit');
            }
        }

    }

</script>
